export const indexBenefitsSliderOptions = (instance, options) => {
    return {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 40,
        cssMode: true,
    }
}